import { useIsBehindFeatureFlag } from "./useFeatureFlag";

export const useShowIntermediateEditedPlans = () => {
  return useIsBehindFeatureFlag("show_all_edited_plans");
};
